import { IBaseState } from "@/services/store/store-types";
import {
  ISDGRating,
  ISDGImpact,
} from "@/modules/profile/services/data/sdg/sdg.interface";

/**
 * Interface that represents the store structure to hold
 * the company's assessments history.
 */
export interface ISDGState extends IBaseState {
  data: {
    rating: ISDGRating | undefined;
    impact: ISDGImpact;
  };
}

export enum ESDGActions {
  FETCH = "profile/sdgRating/fetch",
}

export enum ESDGMutations {
  SET_LOADING = "SET_LOADING",
  SET_ERROR = "SET_ERROR",
  SET_DATA = "SET_DATA",
}
